module.exports = __webpack_public_path__ + "static/media/empty_normal.89da677b.png";